import {
  DataEntryAccidentInjuredProps,
  typedMemo,
  YesNoAnswer,
} from "src/types";
import { FormRow, InputDate, InputGroup, InputText } from "src/ui/widgets";
import { useInjured } from "./injured.hook";
import { InputPhone } from "src/ui/widgets/input-phone/input-phone";

export const InjuredForm = typedMemo(
  ({
    injured_number,
    formikInjuredValues,
    formikInjuredErrors,
    formikInjuredTouched,
    formik,
    validationSchema,
  }: DataEntryAccidentInjuredProps) => {
    const { isMobile, injuredTypeOptions, yesNoOptions, t } = useInjured();

    const { handleChange, handleBlur, setFieldTouched, setFieldValue } = formik;

    const Title = (
      <div className="mb-2">
        {t("commons.injured")} {injured_number + 1}
      </div>
    );

    const Form = (
      <>
        <FormRow
          firstField={
            <InputGroup
              vertically={isMobile ? true : false}
              style="radio"
              name={`accidentData.injuredsInfo.injuredList.${injured_number}.type`}
              handleChange={handleChange}
              handleBlur={handleBlur}
              options={injuredTypeOptions}
              validationSchema={validationSchema}
              touched={formikInjuredTouched?.type}
              value={formikInjuredValues.type}
              error={formikInjuredErrors?.type}
              label={undefined}
              classes="m-0 ps-0"
              classesLabel="m-0 p-0 d-flex align-items-center mb-3"
            />
          }
        />
        {formikInjuredValues.type && (
          <>
            <FormRow
              firstField={
                <InputText
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.name`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.name}
                  value={formikInjuredValues.name}
                  error={formikInjuredErrors?.name}
                  label={`${t("commons.name")}`}
                  placeholder={t("commons.insert")}
                />
              }
              secondField={
                <InputText
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.surname`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.surname}
                  value={formikInjuredValues.surname}
                  error={formikInjuredErrors?.surname}
                  label={`${t("commons.surname")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputDate
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.dateOfBirth`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  setFieldValue={setFieldValue}
                  setFieldTouched={setFieldTouched}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.dateOfBirth}
                  value={formikInjuredValues.dateOfBirth}
                  error={formikInjuredErrors?.dateOfBirth}
                  label={`${t("commons.birth_date")}`}
                  placeholder={t("commons.insert")}
                  disabledTo={undefined}
                  classes="m-0 p-0"
                />
              }
              secondField={
                <InputText
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.placeOfBirth`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.placeOfBirth}
                  value={formikInjuredValues.placeOfBirth}
                  error={formikInjuredErrors?.placeOfBirth}
                  label={`${t("commons.birth_palce")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputText
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.fiscalCode`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.fiscalCode}
                  value={formikInjuredValues.fiscalCode}
                  error={formikInjuredErrors?.fiscalCode}
                  label={`${t("commons.fiscal_code")}`}
                  placeholder={t("commons.insert")}
                />
              }
              secondField={
                <InputText
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.address`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.address}
                  value={formikInjuredValues.address}
                  error={formikInjuredErrors?.address}
                  label={`${t("commons.address_and_details")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputText
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.email`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.email}
                  value={formikInjuredValues.email}
                  error={formikInjuredErrors?.email}
                  label={`${t("commons.email_address")}`}
                  placeholder={t("commons.insert")}
                />
              }
              secondField={
                <InputPhone
                  setFieldTouched={setFieldTouched}
                  setFieldValue={setFieldValue}
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.phoneNumber`}
                  touched={formikInjuredTouched?.phoneNumber}
                  value={formikInjuredValues.phoneNumber}
                  error={formikInjuredErrors?.phoneNumber}
                  label={`${t("commons.phone_number")}`}
                  placeholder={t("commons.insert")}
                />
              }
            />
            <FormRow
              firstField={
                <InputGroup
                  style="radio"
                  name={`accidentData.injuredsInfo.injuredList.${injured_number}.emergencyRoom`}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  options={yesNoOptions}
                  validationSchema={validationSchema}
                  touched={formikInjuredTouched?.emergencyRoom}
                  value={formikInjuredValues.emergencyRoom}
                  error={formikInjuredErrors?.emergencyRoom}
                  label={t("commons.emergency_room")}
                  classes="m-0 ps-0"
                  classesLabel="m-0 p-0 d-flex align-items-center mb-3"
                />
              }
            />
            {formikInjuredValues.emergencyRoom == YesNoAnswer.YES && (
              <FormRow
                firstField={
                  <InputText
                    name={`accidentData.injuredsInfo.injuredList.${injured_number}.emergencyRoomName`}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    validationSchema={validationSchema}
                    touched={formikInjuredTouched?.emergencyRoomName}
                    value={formikInjuredValues.emergencyRoomName}
                    error={formikInjuredErrors?.emergencyRoomName}
                    label={`${t("commons.emergency_room_name")}`}
                    placeholder={t("commons.insert")}
                  />
                }
                secondField={
                  <InputText
                    name={`accidentData.injuredsInfo.injuredList.${injured_number}.emergencyRoomMunicipality`}
                    handleChange={handleChange}
                    handleBlur={handleBlur}
                    validationSchema={validationSchema}
                    touched={formikInjuredTouched?.emergencyRoomMunicipality}
                    value={formikInjuredValues.emergencyRoomMunicipality}
                    error={formikInjuredErrors?.emergencyRoomMunicipality}
                    label={`${t("commons.emergency_room_municipality")}`}
                    placeholder={t("commons.insert")}
                  />
                }
              />
            )}
          </>
        )}
      </>
    );

    return (
      <div className={injured_number > 0 ? "mt-4" : ""}>
        {Title}
        {Form}
      </div>
    );
  }
);
